module.exports = __webpack_public_path__ + "img/icon-app-only.8f5e0aba.svg";